import React, { useEffect, useState } from 'react';
import { useMemberApp } from '../AppProvider';
import { IconMic } from '../components/Icons';

const VOICES = [
  { id: 'en-US', label: 'Vani, American English', hint: 'Default for the US' },
  { id: 'en-GB', label: 'Vani, British English', hint: 'Optional' },
];

export default function VoicePage() {
  const { isPro, setUpgradeOpen } = useMemberApp();
  const [current, setCurrent] = useState(() => localStorage.getItem('byonco:voice') || 'en-US');

  useEffect(() => {
    localStorage.setItem('byonco:voice', current);
  }, [current]);

  const preview = (id) => {
    if (!window.speechSynthesis) return;
    window.speechSynthesis.cancel();
    const utter = new SpeechSynthesisUtterance(
      'This is how I will read answers aloud. I stay inside oncology, and I will never give a dose. You can ask me about side effects, food this cycle, medicines, labs, or what to take to clinic.'
    );
    utter.lang = id;
    window.speechSynthesis.speak(utter);
  };

  if (!isPro) {
    return (
      <div className="by-page">
        <div className="by-empty">
          <div className="glyph"><IconMic /></div>
          <h2>Voice is a PRO feature</h2>
          <p>Hold-to-talk and spoken answers are included with ByOnco PRO.</p>
          <button type="button" className="by-btn by-btn-dark" onClick={() => setUpgradeOpen(true)}>Upgrade to Pro</button>
        </div>
      </div>
    );
  }

  return (
    <div className="by-page">
      <div className="by-center">
        <header className="by-page-head">
          <h1>Voice <span className="by-pro">PRO</span></h1>
          <p className="by-lede">
            Hold Voice in the composer to talk. Everything you can type, you can say: side effects, treatment, appointment prep, food this cycle, labs, medications, and caregiver help. Choose how she sounds when reading a message aloud.
          </p>
        </header>
        <div className="by-list">
          {VOICES.map((voice) => (
            <button
              key={voice.id}
              type="button"
              className={`by-list-card${current === voice.id ? ' is-on' : ''}`}
              onClick={() => setCurrent(voice.id)}
              style={{ textAlign: 'left', cursor: 'pointer' }}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', gap: 12 }}>
                <div>
                  <h3>{voice.label}</h3>
                  <p className="by-fine" style={{ textAlign: 'left' }}>{voice.hint}</p>
                </div>
                <button type="button" className="by-btn by-btn-ghost" onClick={(e) => { e.stopPropagation(); preview(voice.id); }}>
                  Preview
                </button>
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
